import React, {useState} from 'react';

import {FormDialog, MaskedText }from "../../../../controls";
import Validator from "../../validators/JetplanRouteValidator";
import { Icon, IconButton, Tooltip } from '@material-ui/core';
import {formatChars} from "../../../../blocks/FormatCharacters";

const defaultEditProps = {
  style:{fontSize: "0.875rem"}
};

const JetplanRouteDialog = (props) => {

  const [dialogStates, setDialogStates] = useState({
    showDialog: false,
    record: {jetPlanRoute: null},
    handleSave: null,
  });

  const open = (tripLeg, handleSave) => {
    const record = {
      jetPlanRoute: tripLeg.jetPlanRoute,
    };
    setDialogStates({...dialogStates, showDialog:true, record, handleSave});
  }
  const close = () => {
    setDialogStates({...dialogStates, showDialog:false, record: {}, handleSave: null});
  }

  const Dialog = (props) => {
    const classes = props.classes;
    if (dialogStates.showDialog) {
      return (
        <FormDialog
          title={"Jetplan Route"}
          message="Specify the Jetplan Track Code, for the default, clear the field."
          open={dialogStates.showDialog}
          record={dialogStates.record}
          dialogOptions={{maxWidth: "sm", fullWidth: false}}
          classes={classes}
          validator={Validator}
          buttons = {{
            save:{icon: "check_circle", key: "Update", label: "Update", color: "primary", disabled: (status)=>{return status.error}},
            cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
          }}
          onChange={(state) => {
            if (state.buttonPressed === "save") {
              const record = state.record;
              const jetPlanRoute = record.jetPlanRoute;
              if (dialogStates.handleSave) dialogStates.handleSave({jetPlanRoute});
              setDialogStates({...dialogStates, showDialog: false, record: null, handleSave: null});
            } else {
              setDialogStates({...dialogStates, showDialog: false, record: null, handleSave: null});
            }
          }}
        >
          <div>
            <div style={{display: "inline-block", padding: 2}}>Jetplan Route</div>
            <div style={{display: "inline-block", padding: 2}}>
              <MaskedText 
                id="jetPlanRoute"
                mask={"U".repeat(30)}
                maskChar={""}
                alwaysShowMask={false}
                formatChars={formatChars}
                value={props.value}
                onChange={props.onChange}
                inputProps={defaultEditProps}              
              />
            </div>
            <div style={{display: "inline-block", padding: 2, position: "relative"}} checkChildren={true}>
            {(record, changeRecord) => (
              <Tooltip title="Reset Jetplan Route to Default">
                <IconButton
                  style={{padding:2}}
                  onClick={()=> {
                    changeRecord({
                      jetPlanRoute: ""
                    })
                  }
                }><Icon>restore</Icon></IconButton>
              </Tooltip>
            )}
            </div>
          </div>
        </FormDialog>
      )
    }
    return (<></>);
  }
  return {
    Dialog,
    open,
    close
  }

}

export default JetplanRouteDialog;
